export default __webpack_public_path__ + "static/bed-bath-beyond-8-hh-d5f9acb42a6f77bc26cc9c5e0783fbab.webp";